export class ApplicationUDFDetail {
  id: string;
  name?: string;
  type: string;
  value: string;
}
